module.exports = __webpack_public_path__ + "media/95088-success.6bf1f8ef.mp4";